import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface KayakDeal {
  id?: string;
  route: string;
  price: string;
  airline?: string;
  departDate?: string;
  returnDate?: string;
  deepLink?: string;
}

export interface KayakSearchResponse {
  results: KayakDeal[];
  note?: string;
  params?: Record<string, unknown>;
}

export interface KayakSearchPayload {
  origin: string;
  destination: string;
  departDate: string;
  returnDate?: string | null;
  adults: number;
}

@Injectable({
  providedIn: 'root'
})
export class KayakIntegrationService {
  private readonly baseUrl = '/api/kayak';

  constructor(private http: HttpClient) {}

  searchFlights(payload: KayakSearchPayload): Observable<KayakSearchResponse> {
    return this.http.post<KayakSearchResponse>(`${this.baseUrl}/flights/search`, payload);
  }
}
